<template>
  <div class="content">
    <div class="layout">
      <div class="text-end mb-3">
        <select
          v-model="selectedLang"
          class="form-select w-auto d-inline-block"
        >
          <option v-for="lang in languages" :key="lang.code" :value="lang.code">
            {{ lang.language }}
          </option>
        </select>

        <select
          v-model="selectedCountry"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
      </div>

      <div class="d-flex justify-content-center">
        <div style="width: 100%; max-width: 100%">
          <div
            ref="editor"
            class="ckeditor"
            style="width: 100%; border: 1px solid #ddd; padding: 10px"
          ></div>
        </div>
      </div>

      <div class="text-center my-3">
        <div class="row">
          <div class="col"></div>
          <div class="text-end col">
            <button
              type="button"
              class="btn btn-primary"
              @click="publishContent"
            >
              <span v-if="loading">Loading...</span>
              <span v-else>Publish Content</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Countries from '../components/Countries.vue'
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  // components: { Countries },
  data() {
    return {
      loading: false,
      quill: null,
      content: "",
      selectedLang: "en",
      selectedCountry: "CG",
      languages: [],
      countries: [],
    };
  },
   mounted() {
     this.getLanguages();
     this.getCountries();
    //  this.getContent(this.selectedLang, this.selectedCountry)
    // Set default country after countries load, if not set
    if (!this.selectedCountry && this.countries.length > 0) {
      this.selectedCountry = this.countries[0].code;
    }

    this.initQuill();
  },
  computed: {
    langCountryKey() {
      return `${this.selectedLang}__${this.selectedCountry}`;
    },
  },
  watch: {
    langCountryKey(newVal) {
      const [lang, country] = newVal.split("__");
      if (lang && country) {
        this.getContent(lang, country);
      }
    },
  },
  methods: {
    async getLanguages() {
      try {
        const response = await axios.get("languages", {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        this.handleApiError(error);
      }
    },
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    initQuill() {
      this.quill = new Quill(this.$refs.editor, {
        theme: "snow",
        placeholder: "Type here...",
      });

      this.quill.on("text-change", () => {
        this.content = this.quill.root.innerHTML;
      });
    },
    async getContent(lang, country) {
      try {
        console.log("Fetching content for:", lang, country);
        const response = await axios.get(
          `/cnr?lang=${lang}&country=${country}`,
          {
            headers: { "api-key": Cookies.get("authToken") },
          }
        );

        if (response.status === 200) {
          this.quill.root.innerHTML = response.data.content || "";
          this.content = response.data.content || "";
        }
      } catch (error) {
        this.handleApiError(error, true);
      }
    },
    async publishContent() {
      if (!this.content) {
        this.$notify({
          message: "Please enter some content before publishing",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        this.loading = true;
        const response = await axios.post(
          "/cnr",
          { content: this.content, language: this.selectedLang, country: this.selectedCountry },
          { headers: { "api-key": Cookies.get("authToken") } }
        );

        if (response.status === 201) {
          this.$notify({
            message: "Content published successfully.",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        }
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.loading = false;
      }
    },
    handleApiError(error, clearContent = false) {
      if (error.status === 401) {
        this.$notify({
          message: "Session expired, Please login",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        Cookies.remove("authToken");
        this.$router.push("/login");
      } else if (error.status === 404) {
        if (clearContent) {
          this.quill.root.innerHTML = "";
          this.content = "";
        }
        this.$notify({
          message:
            error.response?.data?.message ||
            error.response?.data?.error_message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else {
        this.$notify({
          message:
            error.response?.data?.message ||
            error.response?.data?.error_message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
  },
};
</script>

<style scoped>
.ckeditor {
  height: 60vh;
}
</style>
